export const REDIRECTS = {
  'mejores-depositos': '/usuario/eduardogarcia/articulos/los-mejores-depositos-bancarios-a-plazo-fijo',
  'finizens-vs-indexa-2021-comparativa-2021-cual-elegir':
    '/usuario/avillanuevae/articulos/indexa-capital-vs-finizens-con-cual-invertir-comparativa'
};

export const aliasNoAds = ['Finect Brands'];
export const aliasWithAds = ['finect-talks'];
export const aliasWithTagContent = ['finect-alpha', 'finect-talks', 'finect', 'outlook'];
